import { render } from "./CtaSectionEditor.vue?vue&type=template&id=d543c544"
import script from "./CtaSectionEditor.vue?vue&type=script&lang=js"
export * from "./CtaSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__